<template>
  <div
    v-if="!value"
    class="event-stamp --none">
    <div class="event-stamp__text">
      なし
    </div>
  </div>
  <div
    v-else
    class="event-stamp"
    :style="`background-color: ${stamp.color}`">
    <div class="event-stamp__icon">
      <Icon :icon="stamp.icon" />
    </div>
    <div class="event-stamp__text">
      {{ stamp.text }}
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2'
import { stampByValue } from '@/helper/stamps'

export default {
  components: {
    Icon
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    stamp() {
      return stampByValue[this.value]
    }
  }
}
</script>

<style lang="scss" scoped>
.event-stamp {
  width: 60px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  color: #fff;

  &__icon {
    margin-right: 2px;
    display: flex;
    align-items: center;
  }

  &__text {
    font-size: 14px;
    white-space: nowrap;
  }

  &.--none {
    border: 1px solid #ccc;
    color: black;
  }
}
</style>